import React,{ useEffect, useState,useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import {Button,Card,Form,Row,Col} 
from "react-bootstrap";
import { useParams ,useLocation} from 'react-router-dom';
import "assets/css/grid.css";
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import "react-datetime/css/react-datetime.css";
import Select from 'react-select'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";

import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 

import { Calendar, momentLocalizer,Views } from 'react-big-calendar'
import moment from 'moment';
import 'moment/locale/es';
import { useAgenda } from 'hooks/useAgenda';
import { useContext } from "react";
import { AuthContext } from "auth";
import { useUsuarioSistema } from '../hooks/useUsuarioSistema';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';

moment.locale('es');
const localizer = momentLocalizer(moment);

const customStyles = {
  control: (provided) => ({
    ...provided,
    width: '100%', // Cambia el ancho aquí (en px, %, etc.)
  }),
};

const messages = {
  today: 'Hoy',
  previous: 'Anterior',
  next: 'Siguiente',
  month: 'Mes',
  week: 'Semana',
  day: 'Día',
  agenda: 'Agenda',
  date: 'Fecha',
  time: 'Hora',
  event: 'Evento',
  noEventsInRange: 'No hay eventos en este rango.',
  showMore: total => `+ Ver más (${total})`,
};

function AgendaCompartida(){
  const detalleRef = useRef(null);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const navigate = useNavigate();

  //Usuario logeado
  var {user}= useContext(AuthContext)
  const usuarioSistema=user.Usuario;
  //usuario por parametro
  const parametros = useParams();
  const usuarioParametro=parametros.usuarioAgenda;
  let usuarioInicial=usuarioSistema;

  if(usuarioParametro!==undefined){
    //alert('hola')
    //alert(usuarioParametro)
    usuarioInicial=usuarioParametro;

  }

  const { getActividades,getActividadesFecha,events,eventsTypes,
    updateActividadFecha,insertActividadFecha,respuestaActualizarActividadFecha,
    setRespuestaActualizarActividadFecha,deleteActividadFecha,getTrabajadoras,opcionesSelectorTrabajadoras,
    updateActividadFechaSerie,getSerie,deleteActividadFechaSerie} = useAgenda();
  
  let usuarioAgendaInicial = useUsuarioSistema({Usuario:usuarioInicial});

  //primera carga con usuario sistema
  const [usuarioAgenda,setAgendaUsuario]=useState({Usuario:usuarioInicial,NombreSocial:''});

  const [newEvent, setNewEvent] = useState({ title: '', start: new Date(), end: new Date(),user:usuarioAgenda.Usuario });
  const [showForm, setShowForm] = useState(false);
  const [showEventDetail, setShowEventDetail] = useState(false);

  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [serieEditando,setSerieEditando]=useState(null);

  const [isChangedElements,setChange]=useState(false);
 
  const fechaActual=moment();
  const fechaInicio=fechaActual.add(-7,'day').format('YYYY-MM-DD');
  const fechaFin=fechaActual.add(1, 'month').format('YYYY-MM-DD');
  const [rangeCalendar,setRange]=useState({start:fechaInicio,end:fechaFin})

  //editarserie
  const [editandoSerie, setEditandoSerie] = useState(false);
  const handleSelect = ({ start, end }) => {
    
    setNewEvent({ start, end, title: ''});
    setSelectedSlot({ start, end });  // Guarda el rango seleccionado
    setShowForm(true);
    setShowEventDetail(false);
  };
  const handleAddEvent = async() => {
    setChange(false);
    const resp=await insertActividadFecha(newEvent,usuarioSistema,usuarioAgenda.Usuario);
    if(resp.success)
    {
        setSelectedSlot(null);
        setChange(true);
    }
  };

  const handleLook = (event) => {
    setEditandoSerie(false);
    setSelectedEvent(event);
    setShowEventDetail(true);
    setShowForm(false);
  
  };

  const handleUpdateEvent = async() => {
    setChange(false);
    const resp=await updateActividadFecha(selectedEvent,usuarioSistema,usuarioAgenda.Usuario);
    if(resp)
    {
      setChange(true);
    }
  };
  const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
  const handleRangeChange = (range,view) => {
    //console.log('handleRangeChange')
    if (isInitialLoading) return;

    if (Array.isArray(range)) {
      // Para las vistas como 'week' o 'day'
      const start = range[0];
      let end = range[range.length - 1];
      if(view=='day' || view==undefined){
        end=addDays(end,1);
      }
      setRange({start:start.toISOString().split('T')[0],end:end.toISOString().split('T')[0]})
    } else {
      // Para vistas como 'month'
      //console.log('Mes:', range.start, '->', range.end);
      setRange({start:range.start.toISOString().split('T')[0],end:range.end.toISOString().split('T')[0]})
    }
    //setChange(true); aca al comentarlo ya no se pega el salto pero necesito esto aqui por si se cambia el rango
  }

  const customDayPropGetter = (date) => {
    // Comprueba si la fecha está dentro del rango seleccionado
    if (selectedSlot && moment(date).isSame(selectedSlot.start, selectedSlot.end, 'day', '[]')) {
    //isBetween(selectedSlot.start, selectedSlot.end, 'day', '[]')) {
      return {
        style: {
          backgroundColor: '#ffcccb',  // Cambia el color si está seleccionada
        },
      };
    }
    return {};  // Sin estilo adicional para otras celdas
  };
  const customSlotPropGetter = (date) => {
    
    if (
      selectedSlot &&
      moment(date).isBetween(
        moment(selectedSlot.start),
        moment(selectedSlot.end),
        null, // sin unidad: compara fecha y hora
        '[)' // incluye inicio, excluye fin
      )
    ) {
      
      return {
        style: {
          backgroundColor: '#ffcccb',
        },
      };
    }
    return {};
  };

  const eventPropGetter = (event) => {
   
    const style = {
      borderRadius: '6px',
      border: 0,
      transition: 'all 0.15s ease-in-out',
    };

    const isSelected = selectedEvent && selectedEvent === event;
  /*
    if (event.origen === 'Efectiva') {
      style.backgroundColor = '#16a34a'; // verde
      style.color = '#fff';
    } else if (event.origen === 'Potencial') {
      style.backgroundColor = '#93c5fd'; // azul claro (tailwind: blue-300)
      style.color = '#1e3a8a';           // texto azul oscuro
    }
    */
    if (event.tipoevento === 2) {
      style.backgroundColor = '#16a34a'; // verde
      style.color = '#fff';
    }
    if (isSelected) {
      style.border = '3px solid #1d4ed8';   // azul vibrante
      style.boxShadow = '0 0 4px #1d4ed8';  // un leve glow
    }
  
    return { style };
  };

  const updateRespuestaActualizarActividadFecha=async =>
  {
    //console.log('updateRespuestaActualizarActividadFecha')
    setTimeout(function() {
        setRespuestaActualizarActividadFecha({mensajeTexto:"",estado:false});
        setShowForm(false);
        setShowEventDetail(false); 

    }, 4000);
}
const format = 'DD/MM/YYYY HH:mm';
const fpFormat = 'd/m/Y H:i';
const fpDateOnlyFormat = 'd/m/Y';
const dateOnlyFormat = 'DD/MM/YYYY';


// Opciones comunes de Flatpickr
const commonOpts = {
  enableTime: true,
  dateFormat: fpFormat,
  time_24hr: true,
  allowInput: true,
};
const commonOptsOnlyDate = {
  enableTime: false,
  dateFormat: fpDateOnlyFormat,
  time_24hr: false,
  allowInput: true,
};
const tipoEventoRecurrencia = [
  { value: 1, label: "Único" },
  { value: 2, label: "Frecuente" },
];
const frecuenciaOpciones = [
  { value: 1, label: "Semanal" },
  { value: 2, label: "Cada 2 semanas" },
  { value: 3, label: "Cada 3 semanas" },
  { value: 4, label: "Mensual" }
];

const diasSemana = [
  { value: 1, label: "Lunes" },
  { value: 2, label: "Martes" },
  { value: 3, label: "Miércoles" },
  { value: 4, label: "Jueves" },
  { value: 5, label: "Viernes" },
  { value: 6, label: "Sábado" },
  { value: 0, label: "Domingo" }
];

// Cuando eliges desde el calendario
  const onStartChange = ([date]) =>
  setNewEvent(ev => ({ ...ev, start: date }));
  const onEndChange = ([date]) =>
  setNewEvent(ev => ({ ...ev, end: date }));

  //Start serie
  const onStartSerieChangeNewEvent = ([date]) => {
    console.log(date)
    setNewEvent(ev => ({ ...ev, seriestart: date }));
  };
  
  const onStartSerieCloseNewEvent = (_, dateStr, instance) => {
    const m = moment(dateStr, dateOnlyFormat, true);
  
    if (m.isValid()) {
      setNewEvent(ev => ({ ...ev, seriestart: m.toDate() }));
    } else {
      instance.setDate(newEvent.seriestart, false, fpDateOnlyFormat);
    }
  };
  //
  const onStartSerieChangeEditEvent = ([date]) => {
    console.log(date)
    setSerieEditando(ev => ({ ...ev, seriestart: date }));
  };
  
  const onStartSerieCloseEditEvent = (_, dateStr, instance) => {
    const m = moment(dateStr, dateOnlyFormat, true);
  
    if (m.isValid()) {
      setSerieEditando(ev => ({ ...ev, seriestart: m.toDate() }));
    } else {
      instance.setDate(serieEditando.seriestart, false, fpDateOnlyFormat);
    }
  };
  /*const onStartSerieCloseEditEvent = (_, dateStr, instance) => {
    const m = moment(dateStr, dateOnlyFormat, true);
  
    if (m.isValid()) {
      setSerieEditando(ev => ({ ...ev, seriestart: m.toDate() }));
    } else {
      instance.setDate(serieEditando?.seriestart || null, false);
    }
  };*/

  //End serie
  const onEndSerieChangeNewEvent = ([date]) =>
  setNewEvent(ev => ({ ...ev, serieend: date }));

  const onEndSerieCloseNewEvent = (_, dateStr, instance) => {
    const m = moment(dateStr, dateOnlyFormat, true);
    if (m.isValid()) {
      setNewEvent(ev => ({ ...ev, serieend: m.toDate() }));
    } else {
      instance.setDate(newEvent.serieend, false, fpDateOnlyFormat);
    }
  };
  const onEndSerieChangeEditEvent = ([date]) =>
  setSerieEditando(ev => ({ ...ev, serieend: date }));

  const onEndSerieCloseEditEvent = (_, dateStr, instance) => {
    const m = moment(dateStr, dateOnlyFormat, true);
    if (m.isValid()) {
      setSerieEditando(ev => ({ ...ev, serieend: m.toDate() }));
    } else {
      instance.setDate(serieEditando.serieend, false, fpDateOnlyFormat);
    }
  };


  const onStartChangeEdit = ([date]) =>
  setSelectedEvent(ev => ({ ...ev, start: date }));
  const onEndChangeEdit = ([date]) =>
  setSelectedEvent(ev => ({ ...ev, end: date }));


// Al cerrar el picker (blur o Enter): validamos o revertimos
const onStartClose = (_, dateStr, instance) => {
  const m = moment(dateStr, format, true);
  if (m.isValid()) {
    setNewEvent(ev => ({ ...ev, start: m.toDate() }));
  } else {
    instance.setDate(newEvent.start, false, fpFormat);
  }
};
const onStartCloseEdit = (_, dateStr, instance) => {
  const m = moment(dateStr, format, true);
  if (m.isValid()) {
    setNewEvent(ev => ({ ...ev, start: m.toDate() }));
  } else {
    instance.setDate(newEvent.start, false, fpFormat);
  }
};


const onEndClose = (_, dateStr, instance) => {
  const m = moment(dateStr, format, true);
  if (m.isValid()) {
    setNewEvent(ev => ({ ...ev, end: m.toDate() }));
  } else {
    instance.setDate(newEvent.end, false, fpFormat);
  }
};
const onEndCloseEdit = (_, dateStr, instance) => {
  const m = moment(dateStr, format, true);
  if (m.isValid()) {
    setSelectedEvent(ev => ({ ...ev, end: m.toDate() }));
  } else {
    instance.setDate(newEvent.end, false, fpFormat);
  }
};

const onDelete=async n=>{
    
  confirmAlert({
      title: '',
      message: '¿Seguro desea eliminar la actividad agendada?',
      buttons: [
        {
          label: 'Si',
          onClick: async() => {
            setChange(false);
            const resp=await deleteActividadFecha(selectedEvent,usuarioSistema);
            if(resp)
            {
              setChange(true);
            }
          }
        },
        {
          label: 'No'
          
        }
      ]
    });

}
const onDeleteSerie=async n=>{
    
  confirmAlert({
      title: '',
      message: '¿Seguro desea eliminar la serie completa de actividades?',
      buttons: [
        {
          label: 'Si',
          onClick: async() => {
            setChange(false);
            const resp=await deleteActividadFechaSerie(serieEditando,usuarioSistema);
            if(resp)
            {
              setChange(true);
            }
          }
        },
        {
          label: 'No'
          
        }
      ]
    });

}

const handleUpdateEventSerie = async() => {
  setChange(false);
  const resp=await updateActividadFechaSerie(serieEditando,usuarioSistema,usuarioAgenda.Usuario);
  if(resp)
  {
    setChange(true);
  }
};

  useEffect(() => {
    console.log('Carga inicial')
    async function actividadesCargaFuncion() {
      try {
        setIsInitialLoading(true);             // ⬅️ arranca la carga
        await getActividades();
        const d = { start: rangeCalendar.start, end: rangeCalendar.end };
        await getActividadesFecha(d,usuarioAgenda.Usuario);
        await getTrabajadoras();
      } finally {
        setIsInitialLoading(false);           // ⬅️ cuando termine TODO, liberamos
      }
    }
    actividadesCargaFuncion();
  }, []);

  useEffect(() => {
    console.log('isInitialLoading =>', isInitialLoading);
  }, [isInitialLoading]);

  

    // Opciones compartidas para Flatpickr
    const commonOptions = {
      enableTime: true,
      dateFormat: 'd/m/Y H:i',
      time_24hr: true,
      allowInput: true,
    };

    //opcionesSelectorTrabajadoras=[]

useEffect( () => {
  if(isChangedElements)
  {
    
      async function editarActividadFechaFuncion() {
        updateRespuestaActualizarActividadFecha();
        const d={start:rangeCalendar.start,end:rangeCalendar.end}
        await getActividadesFecha(d,usuarioAgenda.Usuario);
      }
      editarActividadFechaFuncion();
      setChange(false);
  }
}, [isChangedElements]);

useEffect(() => {
  // cuando cambia el rango, recargamos las actividades de ese rango,
  // pero sin cerrar formularios ni mostrar mensaje de actualización
  const cargarPorRango = async () => {
    const d = { start: rangeCalendar.start, end: rangeCalendar.end };
    await getActividadesFecha(d,usuarioAgenda.Usuario);
  };

  // Evitamos correr esto mientras la carga inicial está en curso
  if (!isInitialLoading) {
    cargarPorRango();
  }
}, [rangeCalendar, isInitialLoading,usuarioAgenda]);


useEffect(() => {
  if (!editandoSerie) return;
  if (!selectedEvent?.serieid) return;

  const cargarEventoSerie = async () => {
    
    const serie=await getSerie(selectedEvent.serieid);
    console.warn('ojito')
    console.log('ojito:'+JSON.stringify(serie))
    setSerieEditando(serie);

  };
 if (editandoSerie) {
    console.log('useEffect->editandoSerie')
    cargarEventoSerie();
  }
}, [editandoSerie]);


    return (
            <>
             <style>{
              `
              /* Flatpickr + Bootstrap: evitar look "disabled" por readonly */
              .flatpickr-input[readonly],
              input.form-control.flatpickr-input[readonly] {
                background-color: #fff !important;
                opacity: 1 !important;
                color: #212529 !important;
                cursor: pointer;
              }
            `}
            </style>

          <Select
            placeholder="Usuario Agenda"
                
            options={opcionesSelectorTrabajadoras}
            //value={opcionesSelectorTrabajadoras?.filter(item => sesionFicha?.ProfesionalSicologa?.includes(item.value))}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={ (e,prop) => {     
                console.log(JSON.stringify(e))
                setAgendaUsuario({Usuario:e.value,NombreSocial:e.label});
              }}
            
               // CLAVE: portal para que no lo tape el calendario
            menuPortalTarget={document.body}
            menuPosition="fixed"

            styles={{
              // asegura que el select siga ocupando el ancho que quieres
              container: (base) => ({ ...base, width: "100%" }),

              // CLAVE: z-index alto para el menú y el portal
              menuPortal: (base) => ({ ...base, zIndex: 99999 }),
              menu: (base) => ({ ...base, zIndex: 99999 }),
            }}
                        
            />

<h2>
  
  {usuarioAgenda?.NombreSocial?.trim()
    ? usuarioAgenda.NombreSocial
    : usuarioAgendaInicial?.usuarioSistema?.NombreSocial}


</h2>
            <br></br>
            <div
              style={{
                position: 'relative',
                opacity: isInitialLoading ? 0.4 : 1,              // visual: se ve medio deshabilitado
                pointerEvents: isInitialLoading ? 'none' : 'auto' // clave: no recibe clicks
              }}
            >
            <Calendar
            localizer={localizer}
            events={events}
            defaultView={Views.WEEK}
            selectable
            onSelectSlot={(slotInfo) => {
              handleSelect(slotInfo);
            }}
            dayPropGetter={customDayPropGetter} 
            slotPropGetter={customSlotPropGetter}
            style={{ height: 500 }}
            onSelectEvent={handleLook}
            messages={messages} 
            onRangeChange={handleRangeChange}
            min={new Date(1970, 0, 1, 8, 0)} // Muestra desde las 8:00 AM
            max={new Date(1970, 0, 1, 21, 0)} // Hasta las 9:00 PM
            eventPropGetter={eventPropGetter} 


            />
            {isInitialLoading && (
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                    fontSize: 14,
                    color: '#555',
                  }}
                >
                  Cargando agenda...
                </div>
              )}
            </div>
      <div ref={detalleRef} style={{ marginTop: '1rem' }}>
            
      {
        showForm && (
          <Card>
          <Card.Header>
            <Card.Title as="h4">Agregar Evento</Card.Title>
          </Card.Header>
        
          <Card.Body>
           
            <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Asunto</label>
                <Form.Control
                  placeholder="Título del evento"
                  value={newEvent.title}
                  onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
                  type="text"
                />
              </Col>
            </Row>
        
            <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Actividad</label>
                <Select
                  placeholder="Tipo de Actividad"
                  options={eventsTypes}
                  className="basic-single"
                  classNamePrefix="select"
                  value={eventsTypes.find(i => i.value === newEvent.tipoactividadid)}
                  onChange={(option) => setNewEvent({ ...newEvent, tipoactividadid: option && option.value })}
                  styles={{
                    ...customStyles,
                    control: (base) => ({ ...base, minHeight: 42, width: "100%" }),
                  }}
                    />
              </Col>
            </Row>
            <Row className="g-3 mb-2">
            <Col xs={12} md={6}>
              <label>Tipo de Evento</label>
              <Select
                placeholder="Tipo de Evento"
                options={tipoEventoRecurrencia}
                
                  className="basic-single"
                  classNamePrefix="select"
                  //value={eventsTypes.find(i => i.value === newEvent.tipoevento)}
                  value={tipoEventoRecurrencia.find(i => i.value === newEvent.tipoevento)}
                  onChange={(option) => setNewEvent({ ...newEvent, tipoevento: option.value })}
                  styles={{
                    ...customStyles,
                    control: (base) => ({ ...base, minHeight: 42, width: "100%" }),
                  }}>
              
              </Select>
            </Col>
          </Row>
          { newEvent.tipoevento === 1 && (
            <>
           
            <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Fecha de Inicio:</label>
                <Flatpickr
                  options={{
                    ...commonOpts,
                    defaultDate: newEvent.start,
                    onChange: onStartChange,
                    onClose: onStartClose,
                  }}
                  placeholder={format}
                  className="form-control w-100"
                />
              </Col>
        
              <Col xs={12} md={6}>
                <label>Fecha de Fin:</label>
                <Flatpickr
                  options={{
                    ...commonOpts,
                    defaultDate: newEvent.end,
                    onChange: onEndChange,
                    onClose: onEndClose,
                  }}
                  placeholder={format}
                  className="form-control w-100"
                />
              </Col>
            </Row>
            <Row>
      <Col xs={12} md={12}>
        <label>Participantes</label>
    <Select
        placeholder="Seleccione participantes"
                        isMulti
                        
                        options={opcionesSelectorTrabajadoras}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={opcionesSelectorTrabajadoras.filter(item => newEvent?.participantes?.includes(item.value))}
                        onChange={(selectedOptions) =>
                          setNewEvent({
                            ...newEvent,
                            participantes: selectedOptions.map(opt => opt.value)
                          })}
                        />
                      
</Col>
    </Row>
            </>
          )}
          { newEvent.tipoevento === 2 && (
            <>
             {/* Día y Frecuencia */}
        <Row className="g-3 mt-2">
          <Col xs={12} md={6}>
            <label>Día</label>
            <Select
              value={diasSemana.find(i => i.value === newEvent.dia)}
              onChange={(option) => setNewEvent({ ...newEvent, dia: option.value })}
              options={diasSemana}
            >
              
            </Select>
          </Col>

          <Col xs={12} md={6}>
            <label>Frecuencia</label>
            <Select
              
              value={frecuenciaOpciones.find(i => i.value === newEvent.frecuencia)}
              onChange={(option) => setNewEvent({ ...newEvent, frecuencia: option.value })}
              options={frecuenciaOpciones}
            >
          
            </Select>
          </Col>
        </Row>

    {/* Hora inicio y fin */}
    <Row className="g-3 mt-2">
      <Col xs={12} md={6}>
        <label>Hora Inicio</label>
       
        <Flatpickr
        options={{
          enableTime: true,
          noCalendar: true,      // ⬅️ SOLO hora
          dateFormat: "H:i",     // ⬅️ 24 horas
          time_24hr: true
        }}
        value={newEvent.horainicio || ""}
        onChange={([date]) =>{
          if (!date) return;
          setNewEvent({
            ...newEvent,
            horainicio: moment(date).format("HH:mm")
          })
        }
        }
        className="form-control"
      />
      </Col>

      <Col xs={12} md={6}>
        <label>Hora Fin</label>
        <Flatpickr
        options={{
          enableTime: true,
          noCalendar: true,      // ⬅️ SOLO hora
          dateFormat: "H:i",     // ⬅️ 24 horas
          time_24hr: true
        }}
        value={newEvent.horafin || ""}
        onChange={([date]) =>
        setNewEvent({
          ...newEvent,
          horafin: moment(date).format("HH:mm")
        })
      }
      className="form-control"
    />
      </Col>
    </Row>
    <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Fecha de Inicio Serie:</label>
               
                
              <Flatpickr
                options={{
                  ...commonOptsOnlyDate,
                  defaultDate: newEvent.seriestart,
                  onChange: onStartSerieChangeNewEvent,
                  onClose: onStartSerieCloseNewEvent,
                }}
                placeholder={dateOnlyFormat}
                className="form-control w-100"
              />

              </Col>
        
              <Col xs={12} md={6}>
                <label>Fecha de Fin Serie:</label>
                <Flatpickr
                options={{
                  ...commonOptsOnlyDate,
                  defaultDate: newEvent.serieend,
                  onChange: onEndSerieChangeNewEvent,
                  onClose: onEndSerieCloseNewEvent,
                }}
                placeholder={dateOnlyFormat}//"DD/MM/YYYY"
                className="form-control w-100"
              />
              <label>Las actividades frecuentes pueden crearse hasta un máximo de 6 meses.</label>
              </Col>
    </Row>
   
    </>
    )}
            <MensajeAlerta
              mensajeTexto={respuestaActualizarActividadFecha.mensajeTexto}
              estado={respuestaActualizarActividadFecha.estado}
            />
        
            {/* Botones: alineados, con wrap y gap para móvil */}
            <Row className="mt-4">
              <Col xs={12} className="d-flex flex-wrap justify-content-end gap-2">
                <Button
                  className="btn-fill"
                  type="button"
                  variant="secondary"
                  onClick={() => setShowForm(false)}
                >
                  Cancelar
                </Button>
        
                <Button
                  className="btn-fill"
                  type="button"
                  variant="info"
                  onClick={handleAddEvent}
                >
                  Ingresar
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        

        )
      }

      



      {showEventDetail && !editandoSerie && (
      <Card>
      <Card.Header>
        <Card.Title as="h4">Editar Evento</Card.Title>
      </Card.Header>
    
      <Card.Body>
        {/* Espaciado y columnas responsivas */}
        <Row className="g-3">
          <Col xs={12} md={6}>
            <label>Asunto</label>
            <Form.Control
              value={selectedEvent.title}
              placeholder="Título del evento"
              onChange={(e) => setSelectedEvent({ ...selectedEvent, title: e.target.value })}
              type="text"
              disabled={selectedEvent.origen=='Potencial'}
            />
          </Col>
        </Row>
    
        <Row className="g-3">
          <Col xs={12} md={6}>
            <label>Actividad</label>
            <Select
              isDisabled={selectedEvent.origen=='Potencial'}
              placeholder="Tipo de Actividad"
              options={eventsTypes}
              className="basic-single"
              classNamePrefix="select"
              value={eventsTypes.find(i => i.value === selectedEvent.tipoactividadid)}
              onChange={(option) =>
                setSelectedEvent({ ...selectedEvent, tipoactividadid: option && option.value })
              }
              styles={{
                ...customStyles,
                control: (base) => ({ ...base, minHeight: 42, width: "100%" }),
              }}
             
            />
          </Col>
        </Row>
    
        <Row className="g-3">
          <Col xs={12} md={6}>
            <label>Fecha de Inicio:</label>
            <Flatpickr
              options={{
                ...commonOpts,
                defaultDate: selectedEvent.start,
                onChange: onStartChangeEdit,
                onClose: onStartCloseEdit,
              }}
              placeholder={fpFormat}
              className="form-control w-100"
             
            />
          </Col>
    
          <Col xs={12} md={6}>
            <label>Fecha de Fin:</label>
            <Flatpickr
              options={{
                ...commonOpts,
                defaultDate: selectedEvent.end,
                onChange: onEndChangeEdit,
                onClose: onEndCloseEdit,
              }}
              placeholder={fpFormat}
              className="form-control w-100"
              
            />
             </Col>
          <Col xs={12} md={12}>
        
        {selectedEvent.tipoevento === 1  && (
          <>
        <label>Participantes</label>
          <Select
          placeholder="Seleccione participantes"
          isMulti
          options={opcionesSelectorTrabajadoras}
          className="basic-multi-select"
          classNamePrefix="select"
          value={opcionesSelectorTrabajadoras.filter(item => selectedEvent?.participantes?.includes(item.value))}
          onChange={(selectedOptions) =>
            setSelectedEvent({
                ...selectedEvent,
                participantes: selectedOptions.map(opt => opt.value)
            })}
          />
          </>
          )}
                      
</Col>
        </Row>
    
        <MensajeAlerta
          mensajeTexto={respuestaActualizarActividadFecha.mensajeTexto}
          estado={respuestaActualizarActividadFecha.estado}
        />
    
        <Row className="mt-4">
          <Col xs={12} className="d-flex flex-wrap justify-content-end gap-2">
            <Button
              className="btn-fill"
              type="button"
              variant="secondary"
              onClick={() => setShowEventDetail(false)}
            >
              Cancelar
            </Button>
            {selectedEvent.tipoevento === 2  && (
            <>
              
              <Button
              className="btn-fill"
              variant="warning"
              onClick={() => setEditandoSerie(true)}
              >
              Ir Editar Serie
              </Button>      

            </>   


            )}
    
            <Button
              className="btn-fill"
              type="button"
              variant="danger"
              onClick={onDelete}
            >
              Eliminar
            </Button>
    
            <Button
              className="btn-fill"
              type="button"
              variant="info"
              onClick={handleUpdateEvent}
              disabled={selectedEvent.origen=='Potencial'}
            >
              Actualizar
            </Button>
          </Col>
        </Row>
      </Card.Body>
      </Card>
    

      )}

      </div>

      {/** */}

    { editandoSerie === true && serieEditando && (
    <>
    <Card>
      <Card.Body>
      
        <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Asunto</label>
                <Form.Control
                  placeholder="Título del evento"
                  value={serieEditando.title}
                  onChange={(e) => setSerieEditando({ ...serieEditando, title: e.target.value })}
                  type="text"
                />
              </Col>
            </Row>
        
            <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Actividad</label>
                <Select
                  placeholder="Tipo de Actividad"
                  options={eventsTypes}
                  className="basic-single"
                  classNamePrefix="select"
                  value={eventsTypes.find(i => i.value === serieEditando.tipoactividadid)}
                  onChange={(option) => setSerieEditando({ ...serieEditando, tipoactividadid: option && option.value })}
                  styles={{
                    ...customStyles,
                    control: (base) => ({ ...base, minHeight: 42, width: "100%" }),
                  }}
                    />
              </Col>
            </Row>
            <Row className="g-3 mb-2">
            <Col xs={12} md={6}>
              <label>Tipo de Evento</label>
              <Select
                placeholder="Tipo de Evento"
                options={tipoEventoRecurrencia}
                isDisabled
                  className="basic-single"
                  classNamePrefix="select"
                  value={tipoEventoRecurrencia.find(i => i.value === serieEditando.tipoevento)}
                  onChange={(option) => setSerieEditando({ ...serieEditando, tipoevento: option && option.value })}
                  styles={{
                    ...customStyles,
                    control: (base) => ({ ...base, minHeight: 42, width: "100%" }),
                  }}>
              
              </Select>
            </Col>
          </Row>
          
           
          
        
    <Row className="g-3 mt-2">
          <Col xs={12} md={6}>
            <label>Día</label>
            <Select
              value={diasSemana.find(i => i.value === serieEditando.dia)}
              onChange={(option) => setSerieEditando({ ...serieEditando, dia: option.value })}
              options={diasSemana}
            >
              
            </Select>
          </Col>

          <Col xs={12} md={6}>
            <label>Frecuencia</label>
            <Select
              
              value={frecuenciaOpciones.find(i => i.value === serieEditando.frecuencia)}
              onChange={(option) => setSerieEditando({ ...serieEditando, frecuencia: option.value })}
              options={frecuenciaOpciones}
            >
          
            </Select>
          </Col>
    </Row>
    <Row className="g-3 mt-2">
      <Col xs={12} md={6}>
        <label>Hora Inicio</label>
       
        <Flatpickr
        options={{
          enableTime: true,
          noCalendar: true,      // ⬅️ SOLO hora
          dateFormat: "H:i",     // ⬅️ 24 horas
          time_24hr: true
        }}
        value={serieEditando.horainicio || ""}
        onChange={([date]) =>{
          if (!date) return;
          setSerieEditando({
            ...serieEditando,
            horainicio: moment(date).format("HH:mm")
          })
        }
        }
        className="form-control"
      />
      </Col>

      <Col xs={12} md={6}>
        <label>Hora Fin</label>
        <Flatpickr
        options={{
          enableTime: true,
          noCalendar: true,      // ⬅️ SOLO hora
          dateFormat: "H:i",     // ⬅️ 24 horas
          time_24hr: true
        }}
        value={serieEditando.horafin || ""}
        onChange={([date]) =>
          setSerieEditando({
          ...serieEditando,
          horafin: moment(date).format("HH:mm")
        })
      }
      className="form-control"
    />
      </Col>
    </Row>
    <Row className="g-3">
              <Col xs={12} md={6}>
                <label>Fecha de Inicio Serie:</label>
               
                
              <Flatpickr
                options={{
                  ...commonOptsOnlyDate,
                }}
                value={serieEditando?.seriestart || null}
                placeholder={dateOnlyFormat}
                className="form-control w-100"
                onChange={onStartSerieChangeEditEvent}
                onClose={onStartSerieCloseEditEvent}
              />

              </Col>
        
              <Col xs={12} md={6}>
                <label>Fecha de Fin Serie:</label>
                <Flatpickr
                options={{
                  ...commonOptsOnlyDate,
                  defaultDate: serieEditando.serieend,
                  onChange: onEndSerieChangeEditEvent,
                  onClose: onEndSerieCloseEditEvent,
                }}
                placeholder={dateOnlyFormat}
                className="form-control w-100"
              />
              <label>Las actividades frecuentes pueden crearse hasta un máximo de 6 meses.</label>
              </Col>
    </Row>
  
    <MensajeAlerta
              mensajeTexto={respuestaActualizarActividadFecha.mensajeTexto}
              estado={respuestaActualizarActividadFecha.estado}
            />

    <Row className="mt-4">
          <Col xs={12} className="d-flex flex-wrap justify-content-end gap-2">
            <Button
              className="btn-fill"
              type="button"
              variant="secondary"
              onClick={() => setEditandoSerie(false)}
            >
              Cancelar
            </Button>
           
    
            <Button
              className="btn-fill"
              type="button"
              variant="danger"
              onClick={onDeleteSerie}
            >
              Eliminar Serie
            </Button>
    
            <Button
              className="btn-fill"
              type="button"
              variant="info"
              onClick={handleUpdateEventSerie}
             
            >
              Actualizar Serie
            </Button>
          </Col>
        </Row>

    </Card.Body>
      
      
    </Card>



    </>
  )}    
      
  </>
        )
}
export default AgendaCompartida;